<template>
  <div class="row productPage">
    <div class="col-md-12">
      <List
        :__list="dataArray"
        :__isOnLoad="isListOnload"
        :__editMode="false"
        :__idxOnEdition="-1"
        :__isLightMode="this.isLightMode"
        :__devisIDs="this.devisIDs"
        :__onSelect="this.onSelect"
      ></List>
    </div>

    <transition name="productEditorOverlay">
      <div
        v-if="onEditionId !== null"
        class="productEditorBackdrop"
        @click="cancelAction"
      ></div>
    </transition>

    <transition name="productEditorDrawer">
      <div
        v-if="onEditionId !== null"
        class="productEditorDrawer"
        @click.stop
      >
        <div class="productEditorHead">
          <div>
            <div class="productEditorTitle">
              {{ onEditionIdx === -1 ? 'Nouveau produit' : 'Modifier produit' }}
            </div>
            <div class="productEditorMeta">
              {{ onEditionItem && onEditionItem.name ? onEditionItem.name : 'Edition en cours' }}
            </div>
          </div>
          <button type="button" class="productEditorClose" @click="cancelAction">×</button>
        </div>

        <Edit
          :__item="onEditionItem"
          :__isOnLoad="isEditOnload"
        ></Edit>
      </div>
    </transition>
  </div>
</template>
<script>
import Edit from './Edit';
import List from './List';
export default {
  components: {
    Edit,
    List,
  },
  props: {
    isLightMode:  {
      type: Boolean,
      default: () => {
        return false;
      },
    },

    devisIDs: {
      type: Array,
      default: () => {
        return [];
      },
    },

    onSelect: {
        type: Function,
        default: () => {()=>{}},
      },
  },

  data() {
    return {
      moduleRoute: '/prods',
      onEditionId: null,
      onEditionIdx: -1,
      onEditionItem: null,
      isListOnload: false,
      isEditOnload: false,
      dataArray: [],
      onGoingReq:[],
    };
  },

  methods: {
    createEmptyItem() {
      return {
        name: '',
        desc: '',
        fiche: '',
        ref: '',
        catID: '',
        marqueID: '',
        prixA: 0,
        prixV: 0,
        stock: 0,
        pic: '',
        isActive: 1,
      };
    },

    cancelAction() {
      this.onEditionId = null;
      this.onEditionIdx = -1;
      this.onEditionItem = null;
    },

    showToast(message, variant = 'success') {
      this.$bvToast.toast(message, {
        title: variant === 'success' ? 'Produit' : 'Ajout produit',
        variant,
        solid: true,
        autoHideDelay: 4000,
      });
    },

    normalizeReference(value) {
      return String(value || '').trim().toUpperCase();
    },

    hasDuplicateReference(item) {
      const reference = this.normalizeReference(item && item.ref);
      const currentId = item && item._id ? item._id : null;

      if (!reference) {
        return false;
      }

      return this.dataArray.some((product) => (
        product &&
        product._id !== currentId &&
        this.normalizeReference(product.ref) === reference
      ));
    },

    getApiErrorMessage(error, fallbackMessage) {
      const payload = error && error.response ? error.response.data : null;

      if (payload && payload.error === 'DUPLICATE_PRODUCT_REFERENCE') {
        return `La reference ${payload.reference || ''} existe deja.`.trim();
      }

      if (payload && payload.error === 'PRODUCT_REFERENCE_REQUIRED') {
        return 'La reference du produit est obligatoire.';
      }

      return fallbackMessage;
    },

    getValidationError(item) {
      if (!item || !String(item.name || '').trim()) {
        return 'La designation du produit est obligatoire.';
      }

      if (!String(item.ref || '').trim()) {
        return 'La reference du produit est obligatoire.';
      }

      if (this.hasDuplicateReference(item)) {
        return `La reference ${String(item.ref).trim()} existe deja.`;
      }

      if (Number(item.prixA) < 0 || Number(item.prixV) < 0 || Number(item.stock) < 0) {
        return 'Les prix et le stock doivent etre superieurs ou egaux a zero.';
      }

      return null;
    },

    updPriceAction(itm) {
      this.onGoingReq.push({});
      let $onNext = (response) => {
        this.loadData(itm._id, null, -1);
      };
      
      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      var data = {
        _id: itm._id,
        prixV: itm.newPrice.toFixed(3)
      }
      this.updateAction({ $onNext, $onError, $onComplete, data });
    },

    saveAction() {
      if (this.onEditionId === '__draft__') {
        this.createAction();
        return;
      }

      const validationError = this.getValidationError(this.onEditionItem);

      if (validationError) {
        this.showToast(validationError, 'danger');
        return;
      }

      this.onEditionItem.ref = String(this.onEditionItem.ref).trim();

      this.onGoingReq.push({});
      let $onNext = (response) => {
        this.loadData(this.onEditionId, null, this.onEditionIdx);
      };
      
      const $onError = (error) => {
        this.showToast(
          this.getApiErrorMessage(error, "Le produit n'a pas pu etre modifie."),
          'danger'
        );
      };
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };
      let diff = this.__.differ(
        this.dataArray[this.onEditionIdx],
        this.onEditionItem
      );
      diff.push('_id');
      let data = this._.pick(this.onEditionItem, diff);
      
      this.updateAction({ $onNext, $onError, $onComplete, data });
    },

    toggleActivateAction(id, val) {
      const findIdx = (element) => element._id == id;
      var idx = this.dataArray.findIndex(findIdx);
      this.onGoingReq.push({});
      let $onNext = (response) => {
        this.dataArray[idx].isActive = val;
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      let data = this._.pick(this.dataArray[idx], ['_id', 'isActive']);
      data.isActive = val;
      this.updateAction({ $onNext, $onError, $onComplete, data });
    },

    deleteAction(id) {
      const findIdx = (element) => element._id == id;
      var idx = this.dataArray.findIndex(findIdx);
      this.onGoingReq.push({});
      let $onNext = (response) => {
        if (response.data == 'OK') {
          this.dataArray.splice(idx, 1);
        }
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      let data = this._.pick(this.dataArray[idx], ['_id']);
      this.__.httpAction({
        methode: 'DELETE',
        route: this.moduleRoute+"/"+data._id,
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    editAction(id) {
      const findIdx = (element) => element._id == id;
      var idx = this.dataArray.findIndex(findIdx)
      this.onEditionId = id;
      this.onEditionIdx = idx;
      this.onEditionItem = this._.omit(this.dataArray[idx]);
    },

    updateAction(conf) {
      this.__.httpAction({
        methode: 'POST',
        route: this.moduleRoute,
        data: conf.data,
        onNext: conf.$onNext,
        onError: conf.$onError,
        onComplete: conf.$onComplete,
      });
    },

    createAction() {
      const validationError = this.getValidationError(this.onEditionItem);

      if (validationError) {
        this.showToast(validationError, 'danger');
        return;
      }

      this.onEditionItem.ref = String(this.onEditionItem.ref).trim();

      this.onGoingReq.push({});
      const $onNext = (response) => {
        this.loadData(response.data, () => {
          this.cancelAction();
          this.showToast('Le produit a ete ajoute avec succes.');
        });
      };

      const $onError = (error) => {
        this.showToast(
          this.getApiErrorMessage(
            error,
            "Le produit n'a pas pu etre ajoute. Veuillez reessayer."
          ),
          'danger'
        );
      };
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      const data = this._.omit({ ...this.onEditionItem }, ['_id']);
      this.__.httpAction({
        methode: 'PUT',
        route: this.moduleRoute,
        data,
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    addAction() {
      this.onEditionId = '__draft__';
      this.onEditionIdx = -1;
      this.onEditionItem = this.createEmptyItem();
    },

    loadData(id = null, cb = null, putAt = null) {
      let $onNext = (response) => {
        if (id != null) {
          if (putAt != null) {
            if(putAt === -1) {
              const idx = (element) => element._id === id;
              var position = this.dataArray.findIndex(idx)
              console.log(position );
              this.dataArray[position] = response.data[0];
            } else {
              this.dataArray[putAt] = response.data[0];
            }
            
          } else {
            this.dataArray.unshift(response.data[0]);
          }

          if (cb) cb();
        } else {
          this.dataArray = response.data;
        }
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      this.onGoingReq.push({});
      this.__.httpAction({
        methode: 'GET',
        route: this.moduleRoute+ (id != null ? '/'+id : '/'),
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },
    
  },
  mounted() {
    
    this.loadData();
  },

  watch: {
    onGoingReq: function () {
      this.isListOnload = this.isEditOnload = this.onGoingReq.length > 0;
    },
  },
};
</script>
<style scoped>
.productPage {
  position: relative;
  scroll-padding-top: 180px;
}

.productEditorBackdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.2);
  z-index: 336;
}

.productEditorDrawer {
  position: fixed;
  top: 175px;
  left: 50%;
  right: auto;
  width: min(760px, calc(100vw - 48px));
  max-height: calc(100vh - 195px);
  overflow-x: hidden;
  overflow-y: auto;
  padding: 18px;
  border-radius: 20px;
  background: #eef1f5;
  box-shadow: 0 24px 55px rgba(15, 23, 42, 0.22);
  border: 1px solid rgba(226, 232, 240, 0.95);
  z-index: 337;
  transform: translateX(-50%);
}

.productEditorHead {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}

.productEditorTitle {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
}

.productEditorMeta {
  font-size: 12px;
  color: #64748b;
  margin-top: 4px;
}

.productEditorClose {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 999px;
  background: #ffffff;
  color: #334155;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.12);
}

.productEditorDrawer-enter-active,
.productEditorDrawer-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.productEditorDrawer-enter,
.productEditorDrawer-leave-to {
  transform: translate(-50%, 24px) scale(0.985);
  opacity: 0;
}

.productEditorOverlay-enter-active,
.productEditorOverlay-leave-active {
  transition: opacity 0.22s ease;
}

.productEditorOverlay-enter,
.productEditorOverlay-leave-to {
  opacity: 0;
}

@media (max-width: 768px) {
  .productEditorDrawer {
    top: 110px;
    left: 50%;
    right: auto;
    width: calc(100vw - 20px);
    max-height: calc(100vh - 125px);
    padding: 14px;
    border-radius: 16px;
  }

  .productEditorHead {
    align-items: center;
  }
}
</style>
